jQuery(function ($) {
    const SELECTOR_CONTAINER = '.bloc_carte .point-container';

    function closeAll() {
        $(SELECTOR_CONTAINER).removeClass('active');
    }

    $(document).on('click', function (e) {
        const $target = $(e.target);

        // Un clic dans la popup ne la ferme pas (liens, sélection de texte)
        if ($target.closest('.bloc_carte .carte_coordonnees').length) {
            return;
        }

        const $point = $target.closest('.bloc_carte .point');

        // Clic hors d'un point : on ferme tout
        if (!$point.length) {
            closeAll();
            return;
        }

        // Clic sur un point : on l'ouvre, ou on le referme s'il était déjà ouvert
        const $container = $point.closest('.point-container');
        const wasActive = $container.hasClass('active');

        closeAll();

        if (!wasActive) {
            $container.addClass('active');
        }
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            closeAll();
        }
    });
});